export enum RevisionAssistantControlLevel {
  success = 'success',
  failed = 'failed',
  warning = 'warning',
  notProcessed = 'not_processed'
}
